import { Properties } from "../../core/internal/model/model"
import { Page } from "../../core/internal/page/Page"
import BrowserPropertyGenerator from "./BrowserPropertyGenerator"
import DevicePropertyGenerator from "./DevicePropertyGenerator"

export default class HacklePropertyGenerator {
  static generate(global: any, page?: Page): Properties {
    const currentPage = page ?? Page.createWithCurrentPage()

    return {
      platform: "Web",
      ...BrowserPropertyGenerator.generate(global, currentPage),
      ...DevicePropertyGenerator.generate(global)
    }
  }
}
